import PropTypes from "prop-types";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { CustomTooltip } from "./components/tooltip";
import { option_colors } from "../../service/option";

import { classNames } from "primereact/utils";

export default function ModuleChartPie({
  className = "",
  styles = {},
  data = [],
  COLORS = option_colors,
  options = {},
  isTenThousandUnit = false,
}) {
  const { isTooltip = true, renderCustomizedLabel = false } = options;

  return (
    <div className={classNames("inline-block", className)} style={styles}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={`${renderCustomizedLabel ? "25" : "35"}%`}
            outerRadius={`${renderCustomizedLabel ? "40" : "60"}%`}
            fill="#8884d8"
            stroke="#24313c"
            paddingAngle={0}
            startAngle={-270}
            endAngle={-630}
            dataKey="value"
            label={renderCustomizedLabel}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${entry.name ?? entry.value ?? index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          {isTooltip && (
            <Tooltip
              cursor={{ fill: "#ffffff00" }}
              content={<CustomTooltip isTenThousandUnit={isTenThousandUnit} />}
            />
          )}
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

ModuleChartPie.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.object,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  COLORS: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.shape({
    isTooltip: PropTypes.bool,
    renderCustomizedLabel: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  }),
  isTenThousandUnit: PropTypes.bool,
};
